module.exports = __webpack_public_path__ + "img/icone-alerta.4c1b2bbf.svg";